import { render, staticRenderFns } from "./HanoiSpecial.vue?vue&type=template&id=2ae94dc1&"
import script from "./HanoiSpecial.vue?vue&type=script&lang=js&"
export * from "./HanoiSpecial.vue?vue&type=script&lang=js&"
import style0 from "./HanoiSpecial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports